import { createTheme, Input, MultiSelect, NumberInput, Select, Textarea, TextInput } from '@mantine/core';
import { DateInput, DatePickerInput, MonthPickerInput } from '@mantine/dates';

export const MOBILE_BREAKPOINT = '600px';

export const theme = createTheme({
  fontFamily: 'Inter Variable, sans-serif',
  primaryColor: 'brand',
  components: {
    // Mantine inputs default to "sm" (14px), which makes iOS Safari zoom the page on focus. Bumping
    // them to "md" (16px) is Mantine's own fix: https://help.mantine.dev/q/browser-zooms-on-focus
    Input: Input.extend({ defaultProps: { size: 'md' } }),
    InputWrapper: Input.Wrapper.extend({ defaultProps: { size: 'md' } }),
    TextInput: TextInput.extend({ defaultProps: { size: 'md' } }),
    DateInput: DateInput.extend({ defaultProps: { size: 'md' } }),
    DatePickerInput: DatePickerInput.extend({ defaultProps: { size: 'md' } }),
    MonthPickerInput: MonthPickerInput.extend({ defaultProps: { size: 'md' } }),
    Textarea: Textarea.extend({ defaultProps: { size: 'md' } }),
    Select: Select.extend({ defaultProps: { size: 'md' } }),
    MultiSelect: MultiSelect.extend({ defaultProps: { size: 'md' } }),
    NumberInput: NumberInput.extend({ defaultProps: { size: 'md' } }),
  },
  colors: {
    brand: [
      '#E7ECFB',
      '#BFCEF0',
      '#98B0E6',
      '#7092DB',
      '#4B73D0',
      '#2554C5',
      '#0035BA',
      '#002BA3',
      '#00218C',
      '#001873',
    ],
    accent: [
      '#FEF1EF',
      '#FCDDD9',
      '#FBCAC4',
      '#F9B6AE',
      '#F8A298',
      '#F68F83',
      '#F57B6D',
      '#DA6E61',
      '#B75C52',
      '#8C473F',
    ],
  },
});
